import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'

import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import LoadingButton from '@mui/lab/LoadingButton'

import { renderImportOptionsMenu } from './SubImportMenuItem'

import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepButton from '@mui/material/StepButton'

import Typography from '@mui/material/Typography'

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined'
import EditableSelect from '../EditableSelect'
import TextField from '@mui/material/TextField'

import { useZustand } from '../../hooks/useZustand'
import {
    useContextsStore,
    selectOwnedContexts,
} from '../../stores/useContextsStore'
import usePageInfo from '../../hooks/usePageInfo'

import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { SubImportContext } from './SubImportContext'
import { DialogsContext } from '../../DialogsContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'

import Switch from '@mui/material/Switch'

import axios from 'axios'
import qs from 'qs'

import { slugifyString } from '../../utils/index'
import { generateTextImportItems } from './TextImportItems'

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { MobileDateTimePicker } from '@mui/x-date-pickers'
import ImportingNotice from './ImportingNotice'
import { importErrorMessage } from './importError'

const addPrivateStatementsSelector = state => state.addPrivateStatementsToStore

const steps = ['Start', 'Sources', 'Settings', 'Results']

export default function TwitterImportDialog({
    presetContext = '',
    presetSearchString = '',
    open,
    onClose,
}) {
    const theme = useTheme() // hook to get the current theme

    const { label, location } = usePageInfo()

    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const {
        activeImportDialog,
        setActiveImportDialog,
        backLinkDialog,
        openImportDialog,
        closeImportDialog,
        setPresetSearchString,
    } = React.useContext(DialogsContext)

    // Shared across all import sources so the typed query persists when switching
    const searchString = presetSearchString
    const setSearchString = setPresetSearchString

    const [selectedContext, setSelectedContext] = React.useState(presetContext)

    const [errorMessage, setErrorMessage] = React.useState(null)

    const [importError, setImportError] = React.useState(null)

    const [completedSteps, setCompletedSteps] = React.useState([])

    const [visitedContext, setVisitedContext] = React.useState(false)

    const [numberOfResults, setNumberOfResults] = React.useState('50')

    const [searchLanguage, setSearchLanguage] = React.useState('Default')

    const [searchCountry, setSearchCountry] = React.useState('US')

    const [hideSearchTerms, setHideSearchTerms] = React.useState(true)

    const [excludePageTitles, setExcludePageTitles] = React.useState(false)

    const [advancedSettings, setAdvancedSettings] = React.useState(false)

    const [doNotSaveGraph, setDoNotSaveGraph] = React.useState(false)

    const [modifyAnalyzedText, setModifyAnalyzedText] = React.useState('none')

    const [replaceEntities, setReplaceEntities] = React.useState(false)

    const [fromInsideContext, setFromInsideContext] = React.useState(false)

    const [contentToAnalyze, setContentToAnalyze] = React.useState('tweets')

    const [analyzeHeadersOnly, setAnalyzeHeadersOnly] = React.useState(false)

    const [doNotIncludeCategories, setDoNotIncludeCategories] = React.useState(
        false
    )

    const [excludeMentions, setExcludeMentions] = React.useState(true)

    const [excludeRetweets, setExcludeRetweets] = React.useState(true)

    const [showTwitterAccounts, setShowTwitterAccounts] = React.useState(false)

    const [onlyMentions, setOnlyMentions] = React.useState(false)

    const [queryType, setQueryType] = React.useState('TOP_HASHTAGS')

    const [analyzeUser, setAnalyzeUser] = React.useState(false)

    const [analyzeList, setAnalyzeList] = React.useState(false)

    const [analyzeThread, setAnalyzeThread] = React.useState(false)

    const [includeReplies, setIncludeReplies] = React.useState(false)
    const [dateFrom, setDateFrom] = React.useState('')
    const [dateTo, setDateTo] = React.useState('')

    const menuItems = generateTextImportItems()

    const filteredMenuItems = menuItems.filter(
        ({ textInput }) =>
            textInput.includes('twitterSearch') ||
            textInput.includes(backLinkDialog)
    )

    const { username } = React.useContext(UserContext)
    const addPrivateStatementsToStore = useZustand(addPrivateStatementsSelector)

    React.useEffect(() => {
        console.log('contentToAnalyze', contentToAnalyze)
        switch (contentToAnalyze) {
            case 'tweets':
                setExcludeMentions(true)
                setOnlyMentions(false)
                setShowTwitterAccounts(false)
                setExcludeRetweets(true)
                setAnalyzeUser(false)
                break
            case 'tweets_and_mentions':
                setExcludeMentions(false)
                setOnlyMentions(false)
                setShowTwitterAccounts(true)
                setExcludeRetweets(false)
                setAnalyzeUser(false)
                break
            case 'mentions':
                setExcludeMentions(false)
                setOnlyMentions(true)
                setShowTwitterAccounts(true)
                setExcludeRetweets(false)
                setAnalyzeUser(false)
                break
            case 'user_mentions':
                setExcludeMentions(false)
                setOnlyMentions(true)
                setShowTwitterAccounts(true)
                setExcludeRetweets(false)
                setAnalyzeUser(true)
                break
            case 'user_tweets':
                setExcludeMentions(true)
                setOnlyMentions(false)
                setShowTwitterAccounts(false)
                setExcludeRetweets(true)
                setAnalyzeUser(true)
                break
            case 'user_mixed':
                setExcludeMentions(false)
                setOnlyMentions(false)
                setShowTwitterAccounts(true)
                setExcludeRetweets(false)
                setAnalyzeUser(true)
                break
        }
    }, [contentToAnalyze])

    React.useEffect(() => {
        if (location == 'context' && label) {
            setFromInsideContext(true)
        }
    }, [label])

    React.useEffect(() => {
        if (isTwitterList(searchString)) {
            setAnalyzeList(true)
            setErrorMessage('')
        }
        if (isTweetLink(searchString)) {
            setAnalyzeThread(true)
            setErrorMessage('')
        }
    }, [searchString])

    const contexts = useContextsStore(selectOwnedContexts)
    const contextNames = contexts.map(c => c.name)

    const [activeStep, setActiveStep] = React.useState(2)
    const [skipped, setSkipped] = React.useState(new Set())

    const handleNext = () => {
        let newSkipped = skipped

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleStep = step => {
        setActiveStep(step)
    }

    const handleNumberOfResultsChange = event => {
        setNumberOfResults(event.target.value)
    }

    const handleSearchStringChange = event => {
        setSearchString(event.target.value)
    }

    const handleSearchLanguageChange = event => {
        setSearchLanguage(event.target.value)
    }

    const handleSearchCountryChange = event => {
        setSearchCountry(event.target.value)
    }

    const handleDateFromChange = date => {
        setDateFrom(date)
    }
    const handleDateToChange = date => {
        setDateTo(date)
    }

    const handleAnalyzeListChange = event => {
        setAnalyzeList(event.target.checked)
        if (isTwitterList(searchString)) {
            if (event.target.checked == true) {
                setErrorMessage('')
            } else {
                setErrorMessage(
                    `As you're not analyzing a Twitter list, you might want to change the search query.`
                )
            }
        } else {
            setAnalyzeList(false)
            setErrorMessage('Please, provide a valid Twitter list URL.')
        }
    }

    React.useEffect(() => {
        if (activeSubImportDialog.type) {
            setActiveStep(2)
            setActiveImportDialog(activeSubImportDialog.type)
        }
    }, [activeSubImportDialog])

    React.useEffect(() => {
        switch (activeStep) {
            case 0: // Start
                setActiveSubImportDialog(false)
                setActiveImportDialog('import')
                break
            case 1: // Sources
                setActiveSubImportDialog(false)
                setActiveImportDialog('shortTextImport')
                break
            case 2: // Settings
                if (!presetContext) {
                    const generatedContextName = generatePresetContext(
                        searchString
                    )
                    const contextNameToUse = contextNames.includes(
                        generatedContextName
                    )
                        ? `${generatedContextName}_1`
                        : generatedContextName
                    setSelectedContext(contextNameToUse)
                }
                break
            case 3: // Analysis
                if (!searchString) {
                    setErrorMessage(
                        `Please, provide a search query you'd like to get results from Google for.`
                    )
                    setActiveStep(2)
                    break
                }
                if (!selectedContext) {
                    setErrorMessage(
                        'Please, select the graph to import your data to.'
                    )
                    setActiveStep(2)
                    break
                }
                if (selectedContext) {
                    setCompletedSteps([...completedSteps, 3])
                    setErrorMessage(null)
                    submitDataForm()
                    break
                }
        }
    }, [activeStep])

    const submitDataForm = () => {
        const dataToSend = {
            excludeSearchTerms: hideSearchTerms,
            excludetitles: excludePageTitles ? '1' : '',
            doNotIncludeCategories: doNotIncludeCategories,
            excludeMentions: excludeMentions,
            showTwitterAccounts: showTwitterAccounts,
            onlyMentions: onlyMentions,
            excludeRetweets: excludeRetweets,
            searchQuery: searchString,
            context: selectedContext,
            limit: numberOfResults,
            importLanguage: searchLanguage === 'Default' ? '' : searchLanguage,
            importCountry: searchCountry,
            settings: 'morphemes',
            doNotSaveGraph: doNotSaveGraph,
            modifyAnalyzedText: modifyAnalyzedText,
            replaceEntities: replaceEntities,
            queryType: queryType,
            analyzeUser: analyzeUser,
            analyzeList: analyzeList,
            analyzeThread: analyzeThread,
            dateFrom: dateFrom || '',
            dateTo: dateTo || '',
            includeReplies: includeReplies,
        }

        const dataAsForm = qs.stringify(dataToSend)

        const submitUrl = '/import/twitter'

        axios
            .post(submitUrl, dataAsForm, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // Sending as URL-encoded form data
                },
            })
            .then(response => {
                if (response.data.redirectUrl) {
                    // If you're using window.location
                    window.location.href = response.data.redirectUrl

                    // Or, if you're using React Router's history (assuming you have access to the history object)
                    // history.push(response.data.redirectUrl);
                } else {
                    if (response.data.error) {
                        setErrorMessage(
                            typeof response.data.error == 'object'
                                ? response.data.error.error ||
                                      JSON.stringify(response.data.error)
                                : response.data.error
                        )
                        setImportError(response.data.error)
                        setActiveStep(2)
                    }
                    if (response.data.entryuid) {
                        const postedby = username
                        const res = response.data

                        // Handle private mode statements
                        if (doNotSaveGraph && res.statements) {
                            // Private mode: add statements to Zustand store without saving to DB
                            const entryuids = JSON.parse(res.entryuid)
                            const statementHashtags =
                                res.statementHashtags || {}
                            addPrivateStatementsToStore(
                                res.statements,
                                selectedContext,
                                entryuids,
                                statementHashtags
                            )
                        }

                        if (
                            window.myEventEmitter &&
                            myEventEmitter._events['chatMessage']
                        ) {
                            myEventEmitter.emit('chatMessage', {
                                source: null,
                                postedby: postedby,
                                entryuid: JSON.parse(res.entryuid),
                                entrytext: JSON.parse(res.entrytext),
                                entryname: JSON.parse(res.entryname),
                                tags: JSON.parse(res.tags),
                                timestamp: JSON.parse(res.timestamp),
                                graph: res.graph,
                                stimulateVariability: false,
                                message: res.message,
                                statementHashtags: res.statementHashtags || {},
                                doNotSaveGraph: doNotSaveGraph,
                            })
                            closeImportDialog()
                        }
                    }
                }
            })
            .catch(error => {
                // Handle the error here
                console.error('Received the following error', error)
                setErrorMessage(importErrorMessage(error))
                setImportError(response.data.error)
            })
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        padding: 4,
                        color: theme => theme.palette.text.primary,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {'Analyze X (former Twitter) Data'}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Stepper
                    activeStep={activeStep}
                    sx={{ paddingLeft: 4, paddingRight: 4, paddingTop: 2 }}
                >
                    {steps.map((label, index) => {
                        const stepProps = {}
                        const labelProps = {}

                        return (
                            <Step key={label} {...stepProps}>
                                <StepButton
                                    onClick={() => handleStep(index)}
                                    completed={(
                                        completedSteps.indexOf(index) >= 0
                                    ).toString()}
                                >
                                    <StepLabel
                                        {...labelProps}
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: {
                                                    xs: '0.75rem',
                                                    sm: 'initial',
                                                },
                                            },
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>

                {errorMessage && (
                    <Typography
                        sx={{
                            paddingRight: 4,
                            paddingLeft: 4,
                            paddingTop: 4,
                            paddingBottom: 0,
                        }}
                        color="error"
                        component="div"
                        gutterBottom
                    >
                        {errorMessage}
                    </Typography>
                )}

                {activeStep === 2 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={7}>
                                    <DialogContentText>
                                        Please, specify a keyword, #hashtag, a
                                        @username or a link to a public X list
                                        or a thread that you'd like to research
                                        the discourse for:
                                    </DialogContentText>

                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4 }}
                                    >
                                        <TextField
                                            label={'Twitter search query'}
                                            value={searchString}
                                            variant="outlined"
                                            onChange={handleSearchStringChange}
                                            aria-describedby="searchString-helperText"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderWidth: 2,
                                                        borderColor:
                                                            'info.main',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderWidth: 2,
                                                        borderColor:
                                                            'info.dark',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderWidth: 2,
                                                    },
                                                },
                                            }}
                                        />
                                        {advancedSettings && (
                                            <FormHelperText
                                                id="searchString-helperText"
                                                sx={{ marginTop: 2 }}
                                            ></FormHelperText>
                                        )}
                                    </FormControl>

                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 6 }}
                                    >
                                        <DialogContentText>
                                            Using the import app:
                                        </DialogContentText>
                                        <DialogContent
                                            sx={{
                                                pl: 0,
                                                ml: 0,
                                                marginTop: -2,
                                            }}
                                        >
                                            {renderImportOptionsMenu(
                                                filteredMenuItems,
                                                'twitter'
                                            )}
                                        </DialogContent>
                                    </FormControl>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={4}
                                    sx={{
                                        marginTop: 3,
                                        marginBottom: 4,
                                    }}
                                >
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4, marginBottom: 2 }}
                                    >
                                        <EditableSelect
                                            selectItems={contextNames}
                                            label={'Graph name'}
                                            initialValue={selectedContext}
                                            onChange={name =>
                                                setSelectedContext(name)
                                            }
                                        />
                                    </FormControl>

                                    <FormControl
                                        fullWidth
                                        sx={{
                                            marginTop: 4,
                                            marginBottom: 2,
                                        }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={advancedSettings}
                                                    onChange={event =>
                                                        setAdvancedSettings(
                                                            event.target.checked
                                                        )
                                                    }
                                                />
                                            }
                                            label="Show advanced settings"
                                        />
                                    </FormControl>
                                    {advancedSettings && (
                                        <>
                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <InputLabel id="contentToAnalyze-label">
                                                    Content to analyze
                                                </InputLabel>
                                                <Select
                                                    labelId="contentToAnalyze-label"
                                                    id="contentToAnalyze"
                                                    value={contentToAnalyze}
                                                    onChange={event =>
                                                        setContentToAnalyze(
                                                            event.target.value
                                                        )
                                                    }
                                                    label="Content to analyze"
                                                >
                                                    <MenuItem
                                                        value={'tweets'}
                                                        key="1"
                                                    >
                                                        tweets content only
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={
                                                            'tweets_and_mentions'
                                                        }
                                                        key="2"
                                                    >
                                                        tweets and mentions
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={'mentions'}
                                                        key="3"
                                                    >
                                                        mentions only (social
                                                        network)
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={'user_tweets'}
                                                        key="4"
                                                    >
                                                        tweets of a user
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={'user_mixed'}
                                                        key="4"
                                                    >
                                                        user's content and
                                                        mentions
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={'user_mentions'}
                                                        key="5"
                                                    >
                                                        user's social network
                                                    </MenuItem>
                                                </Select>
                                                {contentToAnalyze ==
                                                    'tweets' && (
                                                    <FormHelperText
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        Will analyze the content
                                                        of the tweets for your
                                                        search query, without
                                                        retweets or mentions.
                                                    </FormHelperText>
                                                )}
                                                {contentToAnalyze ==
                                                    'tweets_and_mentions' && (
                                                    <FormHelperText
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        Will analyze both the
                                                        content and @mentions
                                                        inside the content, as
                                                        well as retweets.
                                                    </FormHelperText>
                                                )}
                                                {contentToAnalyze ==
                                                    'mentions' && (
                                                    <FormHelperText
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        Will include retweets
                                                        and analyze the the
                                                        topic. Note, your graph
                                                        may be empty if there
                                                        are no mentions in the
                                                        tweets. social network
                                                        around
                                                    </FormHelperText>
                                                )}
                                                {contentToAnalyze ==
                                                    'user_tweets' && (
                                                    <FormHelperText
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        Will analyze the latest
                                                        tweets of the @username
                                                        you provide.
                                                    </FormHelperText>
                                                )}
                                                {contentToAnalyze ==
                                                    'user_mixed' && (
                                                    <FormHelperText
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        A mix of user's content
                                                        and social network.
                                                        Includes @mentions and
                                                        retweets.
                                                    </FormHelperText>
                                                )}
                                                {contentToAnalyze ==
                                                    'user_mentions' && (
                                                    <FormHelperText
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        Will build a social
                                                        network from the user's
                                                        tweets. May be empty if
                                                        the user doesn't retweet
                                                        or doesn't mention
                                                        anybody.
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <InputLabel id="numberOfResults-label">
                                                    Number of results to analyze
                                                </InputLabel>
                                                <Select
                                                    labelId="numberOfResults-label"
                                                    id="numberOfResults"
                                                    value={numberOfResults}
                                                    onChange={
                                                        handleNumberOfResultsChange
                                                    }
                                                    label="Number of results to analyze"
                                                >
                                                    <MenuItem value={'20'}>
                                                        20 tweets
                                                    </MenuItem>
                                                    <MenuItem value={'50'}>
                                                        50 tweets
                                                    </MenuItem>
                                                    <MenuItem value={'100'}>
                                                        100 tweets
                                                    </MenuItem>
                                                    <MenuItem value={'200'}>
                                                        200 tweets
                                                    </MenuItem>
                                                    <MenuItem value={'300'}>
                                                        300 tweets (slower)
                                                    </MenuItem>
                                                    <MenuItem value={'400'}>
                                                        400 tweets (slower)
                                                    </MenuItem>
                                                    <MenuItem value={'500'}>
                                                        500 tweets (slower)
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>

                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 2,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            id="doNotIncludeCategories"
                                                            checked={
                                                                doNotIncludeCategories
                                                            }
                                                            onChange={event =>
                                                                setDoNotIncludeCategories(
                                                                    event.target
                                                                        .checked
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label="Do not include tweet information"
                                                />
                                                {doNotIncludeCategories && (
                                                    <FormHelperText
                                                        id="replaceEntities-helperText"
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        If turned off, you won't
                                                        see information about
                                                        the tweet's popularity.
                                                    </FormHelperText>
                                                )}
                                            </FormControl>

                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 2,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            id="includeReplies"
                                                            checked={
                                                                includeReplies
                                                            }
                                                            onChange={event =>
                                                                setIncludeReplies(
                                                                    event.target
                                                                        .checked
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label="Include replies"
                                                />
                                                {includeReplies && (
                                                    <FormHelperText
                                                        id="includeReplies-helperText"
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        If turned on, we will
                                                        include the replies to
                                                        the tweets in the
                                                        analysis.
                                                    </FormHelperText>
                                                )}
                                            </FormControl>

                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <InputLabel id="queryType-label">
                                                    Extract tweets
                                                </InputLabel>
                                                <Select
                                                    labelId="queryType-label"
                                                    id="queryType"
                                                    value={queryType}
                                                    onChange={event =>
                                                        setQueryType(
                                                            event.target.value
                                                        )
                                                    }
                                                    label="Extract tweets"
                                                >
                                                    <MenuItem
                                                        value={'TOP_HASHTAGS'}
                                                        key="1"
                                                    >
                                                        most popular on Twitter
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={
                                                            'RECENT_HASHTAGS'
                                                        }
                                                        key="2"
                                                    >
                                                        most recently posted
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>

                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 2,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            id="analyzeList"
                                                            checked={
                                                                analyzeList
                                                            }
                                                            onChange={
                                                                handleAnalyzeListChange
                                                            }
                                                        />
                                                    }
                                                    label="Analyzing an X list"
                                                />
                                                {analyzeList && (
                                                    <FormHelperText
                                                        id="replaceEntities-helperText"
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        When turned on, we will
                                                        use the URL you provided
                                                        to analyze the X list.
                                                    </FormHelperText>
                                                )}
                                            </FormControl>

                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <InputLabel id="searchLanguage-label">
                                                    Language of the tweets
                                                </InputLabel>
                                                <Select
                                                    labelId="searchLanguage-label"
                                                    id="searchLanguage"
                                                    value={searchLanguage}
                                                    onChange={
                                                        handleSearchLanguageChange
                                                    }
                                                    label="Language of the search results"
                                                >
                                                    <MenuItem value={'Default'}>
                                                        Default Language
                                                    </MenuItem>
                                                    <MenuItem value={'EN'}>
                                                        English
                                                    </MenuItem>
                                                    <MenuItem value={'CN'}>
                                                        Chinese (Simplified)
                                                    </MenuItem>
                                                    <MenuItem value={'TW'}>
                                                        Chinese (Traditional)
                                                    </MenuItem>
                                                    <MenuItem value={'NL'}>
                                                        Dutch
                                                    </MenuItem>
                                                    <MenuItem value={'FR'}>
                                                        French
                                                    </MenuItem>
                                                    <MenuItem value={'DE'}>
                                                        German
                                                    </MenuItem>
                                                    <MenuItem value={'IT'}>
                                                        Italian
                                                    </MenuItem>
                                                    <MenuItem value={'JP'}>
                                                        Japanese
                                                    </MenuItem>
                                                    <MenuItem value={'NO'}>
                                                        Norwegian
                                                    </MenuItem>
                                                    <MenuItem value={'PT'}>
                                                        Portugese
                                                    </MenuItem>
                                                    <MenuItem value={'RU'}>
                                                        Russian
                                                    </MenuItem>
                                                    <MenuItem value={'ES'}>
                                                        Spanish
                                                    </MenuItem>
                                                    <MenuItem value={'SV'}>
                                                        Swedish
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>

                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <InputLabel id="searchCountry-label">
                                                    For users located in
                                                </InputLabel>
                                                <Select
                                                    labelId="searchCountry-label"
                                                    id="searchCountry"
                                                    value={searchCountry}
                                                    onChange={
                                                        handleSearchCountryChange
                                                    }
                                                    label="For users located in"
                                                >
                                                    <MenuItem value={'US'}>
                                                        USA
                                                    </MenuItem>
                                                    <MenuItem value={'AR'}>
                                                        Argentina
                                                    </MenuItem>
                                                    <MenuItem value={'AU'}>
                                                        Australia
                                                    </MenuItem>
                                                    <MenuItem value={'BR'}>
                                                        Brazil
                                                    </MenuItem>
                                                    <MenuItem value={'CA'}>
                                                        Canada
                                                    </MenuItem>
                                                    <MenuItem value={'CN'}>
                                                        China
                                                    </MenuItem>
                                                    <MenuItem value={'FR'}>
                                                        France
                                                    </MenuItem>
                                                    <MenuItem value={'DE'}>
                                                        Germany
                                                    </MenuItem>
                                                    <MenuItem value={'GB'}>
                                                        Great Britain
                                                    </MenuItem>
                                                    <MenuItem value={'HK'}>
                                                        Hong-Kong
                                                    </MenuItem>
                                                    <MenuItem value={'IN'}>
                                                        India
                                                    </MenuItem>
                                                    <MenuItem value={'IT'}>
                                                        Italy
                                                    </MenuItem>
                                                    <MenuItem value={'JP'}>
                                                        Japan
                                                    </MenuItem>
                                                    <MenuItem value={'MX'}>
                                                        Mexico
                                                    </MenuItem>
                                                    <MenuItem value={'NL'}>
                                                        Netherlands
                                                    </MenuItem>
                                                    <MenuItem value={'NZ'}>
                                                        New Zealand
                                                    </MenuItem>
                                                    <MenuItem value={'NO'}>
                                                        Norway
                                                    </MenuItem>
                                                    <MenuItem value={'PT'}>
                                                        Portugal
                                                    </MenuItem>
                                                    <MenuItem value={'RU'}>
                                                        Russia
                                                    </MenuItem>
                                                    <MenuItem value={'ES'}>
                                                        Spain
                                                    </MenuItem>
                                                    <MenuItem value={'SV'}>
                                                        Sweden
                                                    </MenuItem>
                                                    <MenuItem value={'TW'}>
                                                        Taiwan
                                                    </MenuItem>
                                                    <MenuItem value={'CH'}>
                                                        Switzerland
                                                    </MenuItem>
                                                    <MenuItem value={'GB'}>
                                                        United Kingdom
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>

                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <LocalizationProvider
                                                    dateAdapter={AdapterDateFns}
                                                >
                                                    <MobileDateTimePicker
                                                        slots={{
                                                            textField: textFieldProps => (
                                                                <TextField
                                                                    {...textFieldProps}
                                                                />
                                                            ),
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                error: false,
                                                            },
                                                        }}
                                                        label="Date published from"
                                                        value={dateFrom}
                                                        onChange={
                                                            handleDateFromChange
                                                        }
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>

                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <LocalizationProvider
                                                    dateAdapter={AdapterDateFns}
                                                >
                                                    <MobileDateTimePicker
                                                        slots={{
                                                            textField: textFieldProps => (
                                                                <TextField
                                                                    {...textFieldProps}
                                                                />
                                                            ),
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                error: false,
                                                            },
                                                        }}
                                                        label="Date published before"
                                                        value={dateFrom}
                                                        onChange={
                                                            handleDateToChange
                                                        }
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>

                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <InputLabel id="modifyAnalyzedText-label">
                                                    Build a knowledge graph from
                                                </InputLabel>
                                                <Select
                                                    labelId="modifyAnalyzedText-label"
                                                    id="modifyAnalyzedText"
                                                    value={modifyAnalyzedText}
                                                    onChange={event =>
                                                        setModifyAnalyzedText(
                                                            event.target.value
                                                        )
                                                    }
                                                    label="Build a knowledge graph from"
                                                >
                                                    <MenuItem
                                                        value={'none'}
                                                        key="1"
                                                    >
                                                        the words used in text
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={'detectEntities'}
                                                        key="2"
                                                    >
                                                        the words and detected
                                                        entities
                                                    </MenuItem>
                                                    <MenuItem
                                                        value={
                                                            'extractEntitiesOnly'
                                                        }
                                                        key="3"
                                                    >
                                                        only the detected
                                                        entities
                                                    </MenuItem>
                                                </Select>
                                                {modifyAnalyzedText !=
                                                    'none' && (
                                                    <FormHelperText
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        By default, we extract
                                                        the words used in your
                                                        text. You can also
                                                        choose to detect and tag
                                                        entities in your text
                                                        and build a graph from
                                                        them.
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                            {modifyAnalyzedText != 'none' && (
                                                <FormControl
                                                    fullWidth
                                                    sx={{
                                                        marginTop: 2,
                                                        marginBottom: 2,
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                id="replaceEntities"
                                                                checked={
                                                                    replaceEntities
                                                                }
                                                                onChange={event =>
                                                                    setReplaceEntities(
                                                                        event
                                                                            .target
                                                                            .checked
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="Replace entities with root concepts"
                                                    />
                                                    {replaceEntities && (
                                                        <FormHelperText
                                                            id="replaceEntities-helperText"
                                                            sx={{
                                                                marginTop: 1,
                                                            }}
                                                        >
                                                            When turned on, we
                                                            will not only detect
                                                            the entities, but
                                                            also replace them
                                                            with their
                                                            ontological root
                                                            concepts throughout
                                                            your text.
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            )}
                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={
                                                                hideSearchTerms
                                                            }
                                                            onChange={event =>
                                                                setHideSearchTerms(
                                                                    event.target
                                                                        .checked
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label="Hide search terms from graph"
                                                />

                                                <FormHelperText>
                                                    explore the context around
                                                    the search query
                                                </FormHelperText>
                                            </FormControl>
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </>
                )}
                {activeStep === 3 && (
                    <ImportingNotice
                        linkHref={`/${username}/${selectedContext}/google`}
                        message="We are importing your data. Please, wait until this page reloads. If this does not happen in 120 seconds, you can find the graph on"
                    />
                )}
                <DialogActions
                    sx={{
                        paddingRight: 4,
                        paddingLeft: 4,
                        paddingBottom: 4,
                        paddingTop: 2,
                    }}
                >
                    {/* <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button> */}
                    <Button
                        color="inherit"
                        variant="outlined"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1, px: 3, py: 1, fontSize: '0.95rem' }}
                    >
                        Back
                    </Button>

                    <LoadingButton
                        color="info"
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        disabled={!searchString.length > 0 || activeStep == 3}
                        onClick={handleNext}
                        sx={{ px: 4, py: 1, fontSize: '0.95rem' }}
                    >
                        {activeStep === 2 ? 'Visualize' : 'Next'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

function generatePresetContext(searchString) {
    const dateAndTime = new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/-/g, '')
        .replace(/:/g, '')

    if (!searchString) return `twitter_${dateAndTime}`

    const twoFirstSearchQueryWords = slugifyString(
        searchString
            .split(' ')
            .slice(0, 3)
            .join('_')
            .slice(0, 20)
            .replace(/[^\P{L}a-z][^a-z]*/giu, '')
    )

    return `twitter_${twoFirstSearchQueryWords}`
}

function isTwitterList(url) {
    // Regular expression to match the Twitter list URL format
    const twitterListRegex = /^https?:\/\/x\.com\/i\/lists\/\d+$/

    // Test the URL against the regex
    return twitterListRegex.test(url)
}

function isTweetLink(url) {
    const tweetUrlPattern = /^https:\/\/x\.com\/(?:#!\/)?(\w+)\/status\/(\d+)/
    return tweetUrlPattern.test(url)
}
